module.exports = __webpack_public_path__ + "images/976f9df936f024502fad67286799d292-logo_alpha_dark.png";